module.exports = __webpack_public_path__ + "static/media/0010_IMG_LE_SOL_MEGALITH_MEGABLACK.cbb81a7a.webp";